import { render, staticRenderFns } from "./AiVideoPlayer.vue?vue&type=template&id=6424242e&scoped=true"
import script from "./AiVideoPlayer.vue?vue&type=script&lang=js"
export * from "./AiVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./AiVideoPlayer.vue?vue&type=style&index=0&id=6424242e&prod&lang=less&scoped=true"
import style1 from "./AiVideoPlayer.vue?vue&type=style&index=1&id=6424242e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6424242e",
  null
  
)

export default component.exports